import { Component } from '@angular/core';
import { NavController, Platform } from 'ionic-angular';
import { CMService } from "../../providers/cm-service/cm-service";
import { PostDetailsPage } from "../post-details/post-details";

@Component({
    selector: 'page-posts',
    templateUrl: 'posts.html'
})
export class PostsPage {

    private posts: any;
    private showSpinner: boolean;

    constructor(public platform: Platform, public cmService: CMService, public navCtrl: NavController) {
        this.showSpinner = true;
        this.platform = platform;
    }

    ionViewDidLoad() {
        this.loadPosts();
    }

    loadPosts(refresher?) {
        this.cmService.load('https://public-api.wordpress.com/wp/v2/sites/nbbasketball.home.blog/posts').then((result) => {
            this.posts = result;
        }).then(() => {
            this.showSpinner = false;
            if (refresher) {
                refresher.complete();
            }
        })
    }

    openPost(id: number) {
        this.navCtrl.push(PostDetailsPage, {
            'postId': id
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/posts/posts.ts